import { once, omit } from 'lodash';
import { createContext, useContext } from 'react';
import { USE_CONFIRM_STEP_ERROR, USE_INPUT_STEP_ERROR, USE_REVIEW_STEP_ERROR, } from './constants';
export var getCreateFlowContext = once(function () {
    return createContext({});
});
export var useInputStep = function () {
    var context = useContext(getCreateFlowContext());
    if (!context || context.step !== 'input') {
        throw new Error(USE_INPUT_STEP_ERROR);
    }
    return omit(context, ['step']);
};
export var useReviewStep = function () {
    var context = useContext(getCreateFlowContext());
    if (!context || context.step !== 'review') {
        throw new Error(USE_REVIEW_STEP_ERROR);
    }
    return omit(context, ['step']);
};
export var useConfirmStep = function () {
    var context = useContext(getCreateFlowContext());
    if (!context || context.step !== 'confirm') {
        throw new Error(USE_CONFIRM_STEP_ERROR);
    }
    return omit(context, ['step']);
};
//# sourceMappingURL=CreateFlowContext.js.map